var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslateMainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2113_4624)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 45,
    r: 42,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 45,
    r: 43,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9997 24.0002H52.9997V28.6668H48.3073C48.1581 31.6231 47.3856 34.5144 46.0405 37.1511C44.6954 39.7878 42.8081 42.1104 40.5023 43.9665L45.0827 47.4712L42.25 51.1765L36.6663 46.9065L27.5827 53.8528L24.75 50.1475L32.8303 43.9665C30.5246 42.1104 28.6373 39.7878 27.2922 37.1511C25.9471 34.5144 25.1746 31.6231 25.0253 28.6668H20.333V24.0002H34.333V19.3335H38.9997V24.0002ZM36.6663 41.0335L37.2543 40.5832C39.1061 39.167 40.6333 37.3709 41.7332 35.3155C42.8331 33.2601 43.4804 30.9931 43.6313 28.6668H29.7013C29.8523 30.9931 30.4995 33.2601 31.5995 35.3155C32.6994 37.3709 34.2266 39.167 36.0783 40.5832L36.6663 41.0335Z",
    fill: "#8FBFFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3993 42.667H52.7076L52.1803 44.2747L43.7803 69.9413L48.2159 71.3927L50.4116 64.6843H62.5869L64.7803 71.3927L69.2159 69.9413L60.8159 44.2747L60.2909 42.667H54.3993ZM61.0586 60.0177L56.9076 47.3337H56.0909L51.9376 60.0177H61.0586Z",
    fill: "#2859C5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2113_4624",
    x: 0,
    y: 0,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2113_4624"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2113_4624",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslateMainIcon);
export default __webpack_public_path__ + "static/media/translate-main-icon.166e08291b29785987c554ec86282d73.svg";
export { ForwardRef as ReactComponent };